var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTicketRightArrow = function SvgIconTicketRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.717 3.146a.5.5 0 1 0-.707.708L8.956 5.8H1.5a.5.5 0 0 0 0 1h7.513L7.01 8.803a.5.5 0 0 0 .707.707l2.828-2.828.354-.354-.354-.353-2.828-2.829Z",
    fill: "currentColor"
  })));
};
export default SvgIconTicketRightArrow;